/* @flow */

import classNames from 'classnames';
import * as React from 'react';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

import styles from './Avatar.style';

import BaseIcon from 'src/shared/ui/component/icon/BaseIcon';

import svg from './default-avatar.svg';

import type { AvatarProps } from './type/avatarTypes';

type Props = AvatarProps;

const useStyles = createUseThemeStyles(styles);

const DefaultAvatar = ({ layoutClass, variant, alt }: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes = useStyles({ variant });

  const rootClasses = classNames(classes.root, layoutClass);

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return <BaseIcon className={rootClasses} svg={svg} title={alt} />;
};

// Make variants available
export * from './setting/avatarVariants';

export default React.memo<Props>(DefaultAvatar);
